import { getUserLanguageCode } from 'js/lib/language';

import _t from 'i18n!nls/unified-common';

/**
 * @description Returns the disclaimer for the list of career roles module
 */
export const getPathwayDisclaimer = (includeDegrees?: boolean) => {
  const now = new Date();
  const endDate = new Date(now.getFullYear(), now.getMonth(), 1);
  const startDate = new Date(now.getFullYear() - 1, now.getMonth(), 1);
  const fixedEndDate = new Date('December 31, 2024');
  const fixedStartDate = new Date('January 1, 2024');
  const userLocale = getUserLanguageCode();

  return _t(
    includeDegrees
      ? `¹ Median salary, job opening, and degree data are sourced from Lightcast™ Job Postings Report.
  Content Creator, Machine Learning Engineer and Salesforce Development Representative (#{fixedStartDate} - #{fixedEndDate})
  All other job roles (#{startDate} - #{endDate})`
      : `¹ Median salary and job opening data are sourced from Lightcast™ Job Postings Report.
  Content Creator, Machine Learning Engineer and Salesforce Development Representative (#{fixedStartDate} - #{fixedEndDate})
  All other job roles (#{startDate} - #{endDate})`,
    {
      startDate: startDate.toLocaleDateString(userLocale),
      endDate: endDate.toLocaleDateString(userLocale),
      fixedEndDate: fixedEndDate.toLocaleDateString(userLocale),
      fixedStartDate: fixedStartDate.toLocaleDateString(userLocale),
    }
  );
};

/**
 * @description Returns the disclaimer for the XDP career improvement module
 */
export const getXdpCareerImprovementPercentageDisclaimer = () => {
  return _t(
    '² Positive career outcome (e.g., new job, promotion, or raise) within six months of completion. Based on program graduate survey, United States 2022.'
  );
};
